module.exports = __webpack_public_path__ + "img/404.6d2c4848.png";